import { BODY_SM_SM_MEDIUM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const DownloadRejectedTasks = styled.div`
    color: var(--colors-text-action, #2171c6);
    ${BODY_SM_SM_MEDIUM_STYLES};
    cursor: pointer;
    margin-top: var(--spacing-sm, 16px);
`;
